import React from "react";
import { ItemsTable } from "./ReorderPage";

export default function PricingIntelPage() {
  const columns = [
    { key: "sku", label: "SKU", mono: true },
    { key: "brand", label: "Brand" },
    { key: "tire_size", label: "Size", mono: true },
    { key: "cost", label: "Cost", mono: true, align: "right", render: (r) => r.cost ? `$${r.cost.toFixed(2)}` : "—" },
    { key: "selling_price", label: "Price", mono: true, align: "right", render: (r) => r.selling_price ? `$${r.selling_price.toFixed(2)}` : "—" },
    { key: "margin_dollars", label: "Margin $", mono: true, align: "right", render: (r) => r.margin_dollars != null ? `$${r.margin_dollars.toFixed(2)}` : "—" },
    { key: "margin_pct", label: "Margin %", mono: true, align: "right", render: (r) => r.margin_pct != null ? `${r.margin_pct}%` : "—" },
    { key: "avg_daily_sales", label: "Avg/day", mono: true, align: "right", render: (r) => r.avg_daily_sales?.toFixed?.(2) ?? "—" },
    { key: "recommendation_reason", label: "Signal", render: (r) => <span className="text-xs text-[#3B424B]">{r.recommendation_reason}</span> },
  ];
  return <ItemsTable view="pricing" columns={columns} emptyMsg="No pricing signals in the current window." testid="pricing" />;
}
